import type { DiagnosticReportModel } from '@ctw/shared/api/fhir/models/diagnostic-report';
import type { LegacyRowActionsConfigProp } from '@ctw/shared/components/tables/legacy-table';
import { useLabWritebackModal } from '@ctw/shared/content/diagnostic-reports/helpers/lab-writeback-modal';
import { useToggleRead } from '@ctw/shared/content/hooks/use-toggle-read';
import { useFeatureFlag } from '@ctw/shared/context/feature-flag-provider';
import { useWritebacks } from '@ctw/shared/context/writeback-provider';
import { useCallback } from 'react';

export function useDiagnosticRowActions(): (
  r: DiagnosticReportModel,
) => LegacyRowActionsConfigProp<DiagnosticReportModel> {
  const { toggleRead } = useToggleRead();
  const { isWritebackEnabled } = useWritebacks();
  const openLabWritebackModal = useLabWritebackModal();
  const isLabWritebackFeatureEnabled = useFeatureFlag('ehr-integrations-lab-writebacks');
  const isLabWritebackEnabled =
    isWritebackEnabled('diagnostic-reports') && isLabWritebackFeatureEnabled;

  return useCallback(
    (record: DiagnosticReportModel): LegacyRowActionsConfigProp<DiagnosticReportModel> => {
      if (!isLabWritebackEnabled) {
        return [];
      }

      return [
        {
          className:
            'rounded-md border border-transparent px-4 py-2 text-sm font-medium shadow-sm bg-primary-main text-white hover:bg-primary-dark',
          text: 'Add to Record',
          onClick: () => {
            if (!record.isRead) {
              void toggleRead(record);
            }
            openLabWritebackModal(record);
          },
        },
      ];
    },
    [toggleRead, openLabWritebackModal, isLabWritebackEnabled],
  );
}
